export default "__VITE_PUBLIC_ASSET__a50d676d__"